export default {
    HOME: '/',
    DASHBOARD: '/dashboard',

    PROVIDERS_LIST: '/providers',
    PROVIDER_CREATE: '/providers/create',
    PROVIDER_EDIT: '/providers/:id/edit',
    PROGRAM_BOOK_CREATE: '/program-book/create-book/:id',
    PROGRAM_BOOK_DETAIL: '/program-book/graphs/:id',
    PROGRAM_BOOK_V2: '/program-book/v2/:id',
    PROGRAM_BOOK_V3: '/program-book/v3/:id',
    PROGRAM_BOOK_V4: '/program-book/v4/:id',
    PROGRAM_BOOK_TARGET: '/program-book/:id/target/:targetId',
    PROGRAM_BOOK_EDIT: '/program-book/update-book/:id',
    PROGRAM_BOOK_TARGET_CREATE: '/program-book/create-target',
    PROVIDER_DETAIL: '/providers/:id/detail/:tab/:subId?',
    //PROVIDER_DETAIL_SESSION: '/providers/:id/detail/:tab/:seanceId',
    //PROVIDER_DETAIL_SESSION: '/providers/:id/detail/:tab/:seanceId',

    PROVIDER_ANALYTICS_LIST: '/provider-analytics',
    PROVIDER_ANALYTICS_EDIT: '/provider-analytics/:id/edit',
    DEDUCTIONS_LIST: '/deductions',

    DISTRICTS_LIST: '/districts',
    DISTRICT_CREATE: '/districts/create',
    DISTRICT_EDIT: '/districts/:id/edit',
    DISTRICT_DETAIL: '/districts/:id/info',

    WAGES_LIST: '/wages/list/:param?',
    WAGE_CREATE: '/wages/create',
    WAGE_EDIT: '/wages/:id/edit',
    WAGE_DETAIL: '/wages/:id/info',

    REPORT_PAYROLLS_LIST: '/reports',
    REPORT_PAYROLL_DETAIL: '/reports/:id/info',

    PAYROLLS_LIST: '/payrolls',
    PAYROLL_CREATE: '/payrolls/create',
    PAYROLL_EDIT: '/payrolls/:id/edit',

    INCENTIVES_LIST: '/received-bonuses',
    INCENTIVE_CREATE: '/received-bonuses/create',
    INCENTIVE_EDIT: '/received-bonuses/:id/edit',
    //  PAYROLL_DETAIL: '/payrolls/:id/info',

    INVOICES_LIST: '/invoices/list/:status?',
    INVOICE_CREATE: '/invoices/create',
    INVOICE_EDIT: '/invoices/:id/edit',
    INVOICE_DETAIL: '/invoices/:id/info',

    INVOICE_DOCS_LIST: '/invoice-docs/list',

    CREDITS_LIST: '/credits',
    CREDIT_CREATE: '/credits/create',
    CREDIT_EDIT: '/credits/:id/edit',
    CREDIT_DETAIL: '/credits/:id/info',

    PAYMENTS_LIST: '/payments',
    PAYMENT_CREATE: '/payments/create',
    PAYMENT_EDIT: '/payments/:id/edit',
    PAYMENT_DETAIL: '/payments/:id/info',

    CASES_LIST: '/cases/list',
    CASE_CREATE: '/cases/create',
    CASE_EDIT: '/cases/:id/edit',
    CASE_DETAIL: '/cases/:id/info',
    CASE_CALENDAR: '/cases/:id/calendar',

    CALENDAR: '/calendar/:id?',

    SEANCES_LIST: '/sessions/list',
    SEANCE_CREATE: '/sessions/create',
    SEANCE_EDIT: '/sessions/:id/edit',
    SEANCE_DETAIL: '/sessions/:id/info',

    SUBSTITUTIONS_LIST: '/substitutions',
    SUBSTITUTION_CREATE: '/substitutions/create',
    SUBSTITUTION_EDIT: '/substitutions/:id/edit',
    SUBSTITUTION_DETAIL: '/substitutions/:id/info',

    VENDORS_LIST: '/vendors',
    VENDOR_CREATE: '/vendors/create',
    VENDOR_EDIT: '/vendors/:id/edit',
    VENDOR_DETAIL: '/vendors/:id/info',

    STUDENTS_LIST: '/students',
    STUDENT_CREATE: '/students/create',
    STUDENT_EDIT: '/students/:id/edit',
    STUDENT_DETAIL: '/students/:id/info/:tab?',

    ORDERS_LIST: '/orders/list/:status?',
    ORDER_CREATE: '/orders/create',
    ORDER_CREATE_OLD: '/orders/create-old',
    ORDER_EDIT: '/orders/:id/edit',
    ORDER_DETAIL: '/orders/:id/info',

    SERVICE_TYPE_CREATE: '/service-type/create',
    SERVICE_TYPE_EDIT: '/service-type/:id/edit',
    SERVICE_TYPES_LIST: '/service-types',

    SERVICE_LOCATIONS_LIST: '/service-locations',
    SERVICE_LOCATION_CREATE: '/service-location/create',
    SERVICE_LOCATION_EDIT: '/service-location/:id/edit',

    AGENCY_INFO: '/agency-info/:type?',

    EMAILS_LOG: '/emails-log',

    CASES_NO_CONSENTS_LIST: '/case-no-consents',
    CASES_NO_PRINCIPALS_LIST: '/case-no-principal',

    ORDER_REMAINING_HOURS_REPORTS_LIST: '/order-remaining-hours-reports',

    ORDER_EXPIRED_REPORTS_LIST: '/order-expired-reports',

    PROVIDER_REPORTS_LIST: '/provider-reports',
    SEANCE_REPORTS_LIST: '/session-reports',
    WORKED_HOURS_REPORTS_LIST: '/invoiced-hours-reports',
    NON_BILLED_SESSIONS_REPORTS_LIST: '/non-billed-sessions-reports',

    COMPLETE_REGISTRATION: '/registration/complete',
    LOGOUT: '/logout',
    LOGIN_CUSTOMER: '/login',
    LOGIN_CODE: '/2fa',
    PROFILE: '/profile',
    PASSWORD_RECOVERY: '/password-recovery',

    EXPENSES_LIST: '/expenses',
    EXPENSE_CREATE: '/expenses/create',
    EXPENSE_EDIT: '/expenses/:id/edit',
    EXPENSE_DETAIL: '/expenses/:id/info',

    INTERNAL_CREATE: '/internals/create',
    INTERNAL_EDIT: '/internals/:id/edit',
    INTERNAL_DETAIL: '/internals/:id/info',
    INTERNALS_LIST: '/internals',

    ADMIN_WORKS_LIST: '/admin-work',
    ADMIN_WORK_CREATE: '/admin-works/create',
    ADMIN_WORK_EDIT: '/admin-works/:id/edit',
    ADMIN_WORK_DETAIL: '/admin-works/:id/info',

    BONUSES_LIST: '/bonuses',

    INTAKE_PARENT_FORM: '/intake/:id/form/:formId',
    INTAKE_PARENT_FORM_SUCCESS: '/intake/success',

    CONTRACT_CREATE: '/contracts/create/:id',
};
